import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "antd";
import React, { useState } from "react";
import "./Auth.css";
const Auth = (props) => {
  const {
    authTitle,
    authDescription,
    authFields,
    authSubmit,
    authImage,
    onsubmit,
    successMessage,
    errorMessage,
    textImage,
  } = props;

  const [visible, setVisible] = useState(false);

  return (
    <div className="Admin_Auth_container">
      <div className="Admin_Auth_authBlock">
        <form className="Admin_Auth_AuthForm" onSubmit={onsubmit}>
          {textImage && <div className="Admin_LogoTextImage">{textImage}</div>}
          <img className="Auth_authImage" src={authImage} alt="auth" />
          {authFields.map((itemField, indexField) => {
            switch (itemField.type) {
              case "text":
                return (
                  <div className="Admin_Auth_itemField" key={indexField}>
                    <label
                      htmlFor="username"
                      className="Admin_Auth_itemFieldLabel"
                    >
                      {itemField.label}
                    </label>
                    <Input
                      placeholder={itemField.placeholder ?? ""}
                      value={itemField.value}
                      id="username"
                      type="text"
                      name="username"
                      autoComplete="username"
                      onChange={(event) => {
                        if (typeof itemField.setField === "function") {
                          itemField.setField(event.target.value);
                        }
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          onsubmit();
                        }
                      }}
                    />
                    {itemField.error && (
                      <div className="Admin_Auth_itemFieldError">
                        {itemField.error}
                      </div>
                    )}
                  </div>
                );
              case "password":
                return (
                  <div className="Admin_Auth_itemField" key={indexField}>
                    <label
                      htmlFor="password"
                      className="Admin_Auth_itemFieldLabel"
                    >
                      {itemField.label}
                    </label>
                    <Input
                      placeholder={itemField.placeholder ?? ""}
                      id="password"
                      value={itemField.value}
                      type={!visible ? "password" : "text"}
                      name="password"
                      autoComplete="current-password"
                      suffix={
                        !visible ? (
                          <EyeOutlined onClick={() => setVisible(true)} />
                        ) : (
                          <EyeInvisibleOutlined onClick={() => setVisible(false)} />
                        )
                      }
                      onChange={(event) => {
                        if (typeof itemField.setField === "function") {
                          itemField.setField(event.target.value);
                        }
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          onsubmit();
                        }
                      }}
                    />
                    {itemField.error && (
                      <div className="Admin_Auth_itemFieldError">
                        {itemField.error}
                      </div>
                    )}
                  </div>
                );
              default:
                return null;
            }
          })}
        </form>
        <Button
          className="Admin_Auth_authSubmit"
          onClick={() => {
            if (typeof onsubmit === "function") {
              onsubmit();
            }
          }}
        >
          {authSubmit}
        </Button>
        <div className="Admin_MediaIcons">
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faFacebook}
              style={{ color: "#405DE6" }}
              className="Admin_Auth_SocialIcon"
            />
          </a>
          <a
            href="https://instagram.com/zeuspix_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faInstagram}
              style={{ color: "#C13584" }}
              className="Admin_Auth_SocialIcon"
            />
          </a>
          <a
            href="https://api.whatsapp.com/send/?phone=555599174436&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              style={{ color: "green" }}
              className="Admin_Auth_SocialIcon"
            />
          </a>
        </div>
        {successMessage && (
          <div className="Admin_Auth_successMessage">{successMessage}</div>
        )}
        {errorMessage && (
          <div className="Admin_Auth_errorMessage">
            <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Auth;
